{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Vytvořit nový tým",
    "HEADER": "Týmy",
    "LOADING": "Načítám týmy",
    "DESCRIPTION": "Týmy vám umožňují organizovat agenty do skupin na základě jejich odpovědností. Agent může patřit do více týmů. Při spolupráci můžete přiřadit konverzace konkrétním týmům.",
    "LEARN_MORE": "Více o týmech",
    "LIST": {
      "404": "V tomto účtu nejsou vytvořeny žádné týmy.",
      "EDIT_TEAM": "Upravit tým",
      "NONE": "Nic"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Vytvořit nový tým",
        "DESC": "Přidejte název a popis k vašemu novému týmu."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Přidat agenty do týmu",
        "TITLE": "Přidat agenty do týmu - {teamName}",
        "DESC": "Přidejte agenty do vašeho nově vytvořeného týmu. To vám umožní spolupracovat jako tým na konverzacích, dostávat oznámení o nových událostech ve stejné konverzaci."
      },
      "WIZARD_CREATE": {
        "TITLE": "Vytvořit",
        "BODY": "Vytvořit nový tým agentů."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Přidat agenty",
        "BODY": "Přidat agenty do týmu."
      },
      "WIZARD_FINISH": {
        "TITLE": "Dokončit",
        "BODY": "Vše je nastaveno!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Upravit údaje o vašem týmu",
        "DESC": "Upravit název a popis vašeho týmu.",
        "BUTTON_TEXT": "Aktualizovat tým"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Aktualizovat agenty v týmu",
        "TITLE": "Přidat agenty do týmu - {teamName}",
        "DESC": "Přidejte agenty do vašeho nově vytvořeného týmu. Všichni přidaní agenti budou informováni, když je konverzace přiřazena tomuto týmu."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Údaje o týmu",
        "ROUTE": "settings_teams_edit",
        "BODY": "Změňte název, popis a další detaily."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Upravit agenty",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "Upravit agenty ve vašem týmu."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Dokončit",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "Vše je nastaveno!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Nepodařilo se uložit údaje týmu. Zkuste to znovu."
    },
    "AGENTS": {
      "AGENT": "AGENT",
      "EMAIL": "E-MAIL",
      "BUTTON_TEXT": "Přidat agenty",
      "ADD_AGENTS": "Přidávání agentů do vašeho týmu...",
      "SELECT": "vybrat",
      "SELECT_ALL": "vybrat všechny agenty",
      "SELECTED_COUNT": "Vybráno {selected} z {total} agentů."
    },
    "ADD": {
      "TITLE": "Přidat agenty do týmu - {teamName}",
      "DESC": "Přidejte agenty do vašeho nově vytvořeného týmu. To vám umožní spolupracovat jako tým na konverzacích, dostávat oznámení o nových událostech ve stejné konverzaci.",
      "SELECT": "vybrat",
      "SELECT_ALL": "vybrat všechny agenty",
      "SELECTED_COUNT": "Vybráno {selected} z {total} agentů.",
      "BUTTON_TEXT": "Přidat agenty",
      "AGENT_VALIDATION_ERROR": "Vyberte alespoň jednoho agenta."
    },
    "FINISH": {
      "TITLE": "Váš tým je připraven!",
      "MESSAGE": "Nyní můžete spolupracovat jako tým na konverzacích. Příjemnou podporu ",
      "BUTTON_TEXT": "Dokončit"
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazat",
      "API": {
        "SUCCESS_MESSAGE": "Tým byl úspěšně smazán.",
        "ERROR_MESSAGE": "Nepodařilo se smazat tým. Zkuste to znovu."
      },
      "CONFIRM": {
        "TITLE": "Opravdu chcete smazat tým?",
        "PLACE_HOLDER": "Pro potvrzení napište {teamName}",
        "MESSAGE": "Smazání týmu odstraní přiřazení týmu z konverzací přiřazených tomuto týmu.",
        "YES": "Vymazat ",
        "NO": "Zrušit"
      }
    },
    "SETTINGS": "Nastavení",
    "FORM": {
      "UPDATE": "Aktualizovat tým",
      "CREATE": "Vytvořit tým",
      "NAME": {
        "LABEL": "Název týmu",
        "PLACEHOLDER": "Příklad: Prodej, Zákaznická podpora"
      },
      "DESCRIPTION": {
        "LABEL": "Popis týmu",
        "PLACEHOLDER": "Krátký popis tohoto týmu."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Povolit automatické přiřazení pro tento tým."
      },
      "SUBMIT_CREATE": "Vytvořit tým"
    }
  }
}
